<template>
  <div
    @click="toggleLanguage"
    :class="[custom]"
    class="group h-11 group rounded-full flex items-center relative cursor-pointer"
  >
    <div class="font-semibold truncate pl-4 pr-4">
     {{ actualLocale }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'base-language',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    custom: {
      type: [String, Array],
      default: ''
    },
    onMobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {}
  },
  computed: {
    actualLocale () {
      const actualLocale = this.$i18n.locale
      if (actualLocale === 'es-ES') return 'ES'
      if (actualLocale === 'en-EN') return 'EN'
      if (actualLocale === 'en') return 'EN'
      return this.$i18n.locale
    },
  },
  methods: {
    toggleLanguage: function () {
      this.$emit('toggleLanguage')
    }
  }
}
</script>
